import $ from "jquery"

$('.js-founder-alex').on('click', function(){
    $('.founder__wrap--bartek').removeClass('founder__wrap--active founder__wrap--active-index');
    $('.founder__wrap--alex').toggleClass('founder__wrap--active');

    setTimeout(function(){
        $('.founder__wrap--alex').toggleClass('founder__wrap--active-index');
    }, 200);
});

$('.js-founder-bartek').on('click', function(){
    $('.founder__wrap--alex').removeClass('founder__wrap--active founder__wrap--active-index');
    $('.founder__wrap--bartek').toggleClass('founder__wrap--active');

    setTimeout(function(){
        $('.founder__wrap--bartek').toggleClass('founder__wrap--active-index');
    }, 200);
});